import { GET_JOB_LISTINGS } from '../../endpoints'; 
import { JobListing } from '../../types/jobs'; 
import makeAuthenticatedRequest from '../base-api';

const jobListingsQueryKey = ['jobListings'];

const getJobListings = async (): Promise<{
  success: boolean;
  data?: JobListing[];
  message?: string;
}> => {
  try {
    const response = await makeAuthenticatedRequest(GET_JOB_LISTINGS);
    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export { getJobListings, jobListingsQueryKey };